import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {NgbCollapseModule, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {routing} from "./app.routing";

import {NavigationComponent} from './shared/header-navigation/navigation.component';
import {SidebarComponent} from './shared/sidebar/sidebar.component';
import {BreadcrumbComponent} from './shared/breadcrumb/breadcrumb.component';
import {RightSidebarComponent} from './shared/right-sidebar/rightsidebar.component';
import {AppComponent} from './app.component';
import {HashLocationStrategy, LocationStrategy} from '@angular/common';
import {UserService} from "./services/user.service";
import {CoursesService} from "./services/courses.service";
import {CartService} from "./services/cart.service";
import {AuthService} from "./services/auth.service";
import {AuthGuard} from "./services/auth.guard";
import {OrderService} from "./services/order.service";
import {WalletService} from "./services/wallet.service";
import {MainPipe} from "./pipe/main-pipe.module";
import {Ng2CompleterModule} from "ng2-completer";
import {UiSwitchModule} from "ng2-ui-switch/dist";
import {UserModalProfileService} from "./services/user-modal-profile.service";
import {RefundService} from "./services/refund.service";
import {EngineService} from "./services/engine.service";
import {ProductService} from "./services/product.service";
import {PurchaseService} from "./services/purchase.service";
import {TooltipModule} from "ngx-tooltip";
import {NgbdPopTooltip} from "./pages/component/popover-tooltip/popover-tooltip.component";
import {ReceiptService} from "./services/receipt.service";
import {StatementService} from "./services/statement.service";
import {PaymentModalService} from "./services/payment-modal.service";
import {numberOnly} from "./services/onlyNumberKey";
import {StockService} from "./services/stock.service";
import {StockTransferService} from "./services/stock-transfer.service";
import {StockCheckService} from "./services/stock-check.service";
import {NgxSelectModule} from "ngx-select-ex";
import {HeaderService} from "./services/header.service";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";

@NgModule({
  declarations: [
    AppComponent,
    NavigationComponent,
    BreadcrumbComponent,
    SidebarComponent,
    RightSidebarComponent,
    NgbdPopTooltip,
  ],
  imports: [
    routing,
    BrowserModule,
    BrowserAnimationsModule,
    NgbModule.forRoot(),
    FormsModule,
    HttpModule,
    MainPipe,
    Ng2CompleterModule,
    ReactiveFormsModule,
    UiSwitchModule,
    TooltipModule,
    NgxSelectModule,
    NgbCollapseModule.forRoot()
  ],
  providers: [{
    provide: LocationStrategy,
    useClass: HashLocationStrategy
  }, HeaderService,CoursesService, CartService, AuthService, AuthGuard, OrderService, WalletService,StockService,StockTransferService,StockCheckService,numberOnly, UserService, UserModalProfileService, RefundService, ProductService,PaymentModalService, PurchaseService, EngineService, ReceiptService, StatementService],
  bootstrap: [AppComponent]
})
export class AppModule {}




// WEBPACK FOOTER //
// ./src/app/app.module.ts